/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

export const supportedModels: {
  'Model Architecture': string;
  'Main Model': string;
  Models: string[];
  'HuggingFace model examples': string[];
  'More examples': boolean;
  LoRA: boolean;
}[] = [
  {
    'Model Architecture': 'ArcticForCausalLM',
    'Main Model': 'Arctic',
    Models: ['Arctic'],
    'HuggingFace model examples': ['Snowflake/snowflake-arctic-instruct'],
    'More examples': true,
    LoRA: false,
  },
  {
    'Model Architecture': 'BaichuanForCausalLM',
    'Main Model': 'Baichuan',
    Models: ['Baichuan'],
    'HuggingFace model examples': [
      'baichuan-inc/Baichuan2-13B-Chat',
      'baichuan-inc/Baichuan2-7B-Chat',
    ],
    'More examples': true,
    LoRA: false,
  },
  {
    'Model Architecture': 'BlenderbotForConditionalGeneration',
    'Main Model': 'Blenderbot',
    Models: ['Blenderbot'],
    'HuggingFace model examples': ['facebook/blenderbot-3B'],
    'More examples': false,
    LoRA: false,
  },
  {
    'Model Architecture': 'BloomForCausalLM',
    'Main Model': 'BLOOM',
    Models: ['BLOOM', 'BLOOMZ'],
    'HuggingFace model examples': ['bigscience/bloom'],
    'More examples': true,
    LoRA: false,
  },
  {
    'Model Architecture': 'CohereForCausalLM',
    'Main Model': 'Cohere',
    Models: ['Command R', 'Command R+'],
    'HuggingFace model examples': ['CohereForAI/c4ai-command-r-plus'],
    'More examples': true,
    LoRA: false,
  },
  {
    'Model Architecture': 'DbrxForCausalLM',
    'Main Model': 'DBRX',
    Models: ['DBRX'],
    'HuggingFace model examples': ['databricks/dbrx-instruct'],
    'More examples': true,
    LoRA: false,
  },
  {
    'Model Architecture': 'DeepseekForCausalLM',
    'Main Model': 'DeepSeek',
    Models: ['DeepSeek'],
    'HuggingFace model examples': ['deepseek-ai/deepseek-moe-16b-chat'],
    'More examples': false,
    LoRA: false,
  },
  {
    'Model Architecture': 'ExaoneForCausalLM',
    'Main Model': 'EXAONE',
    Models: ['EXAONE'],
    'HuggingFace model examples': ['LGAI-EXAONE/EXAONE-3.0-7.8B-Instruct'],
    'More examples': false,
    LoRA: true,
  },
  {
    'Model Architecture': 'FalconForCausalLM',
    'Main Model': 'Falcon',
    Models: ['Falcon'],
    'HuggingFace model examples': ['tiiuae/falcon-40b'],
    'More examples': true,
    LoRA: false,
  },
  {
    'Model Architecture': 'Gemma2ForCausalLM',
    'Main Model': 'Gemma2',
    Models: ['Gemma 2'],
    'HuggingFace model examples': ['google/gemma-2-9b-it', 'google/gemma-2-27b-it'],
    'More examples': true,
    LoRA: true,
  },
  {
    'Model Architecture': 'GemmaForCausalLM',
    'Main Model': 'Gemma',
    Models: ['CodeGemma', 'Gemma'],
    'HuggingFace model examples': ['google/codegemma-7b-it', 'google/gemma-7b-it'],
    'More examples': true,
    LoRA: true,
  },
  {
    'Model Architecture': 'GPT2LMHeadModel',
    'Main Model': 'GPT2',
    Models: ['GPT2'],
    'HuggingFace model examples': ['openai-community/gpt2-xl'],
    'More examples': true,
    LoRA: false,
  },
  {
    'Model Architecture': 'GPTJForCausalLM',
    'Main Model': 'GPT-J',
    Models: ['GPT-J'],
    'HuggingFace model examples': ['EleutherAI/gpt-j-6b'],
    'More examples': true,
    LoRA: false,
  },
  {
    'Model Architecture': 'GPTNeoXForCausalLM',
    'Main Model': 'GPT-NeoX',
    Models: ['GPT-NeoX', 'Pythia', 'Dolly', 'StableLM'],
    'HuggingFace model examples': ['EleutherAI/gpt-neox-20b', 'databricks/dolly-v2-12b'],
    'More examples': true,
    LoRA: false,
  },
  {
    'Model Architecture': 'Grok1ForCausalLM',
    'Main Model': 'Grok-1',
    Models: ['Grok-1'],
    'HuggingFace model examples': ['xai-org/grok-1'],
    'More examples': false,
    LoRA: false,
  },
  {
    'Model Architecture': 'LlamaForCausalLM',
    'Main Model': 'Llama',
    Models: [
      'Llama 3.1',
      'Llama 3',
      'Llama 2',
      'CodeLlama',
      'OpenLLaMA',
      'Hermes 3',
      'Vicuna',
      'Yi',
      'WizardLM',
      'WizardMath',
      'WizardCoder',
    ],
    'HuggingFace model examples': [
      'meta-llama/Meta-Llama-3.1-405B-Instruct',
      'meta-llama/Meta-Llama-3-70B-Instruct',
      'meta-llama/CodeLlama-70b-hf',
      'NousResearch/Hermes-3-Llama-3.1-8B',
      'lmsys/vicuna-13b-v1.3',
      '01-ai/Yi-34B',
      'WizardLMTeam/WizardLM-70B-V1.0',
    ],
    'More examples': true,
    LoRA: true,
  },
  {
    'Model Architecture': 'MistralForCausalLM',
    'Main Model': 'Mistral',
    Models: ['Mistral 7B', 'Mistral Nemo', 'Mistral Large 2', 'Mathstral'],
    'HuggingFace model examples': [
      'mistralai/Mistral-7B-Instruct-v0.3',
      'mistralai/Mistral-Nemo-Instruct-2407',
      'mistralai/Mistral-Large-Instruct-2407',
      'mistralai/Mathstral-7B-v0.1',
    ],
    'More examples': true,
    LoRA: true,
  },
  {
    'Model Architecture': 'MixtralForCausalLM',
    'Main Model': 'Mixtral',
    Models: ['Mixtral 8x7B', 'Mixtral 8x22B', 'Zephyr'],
    'HuggingFace model examples': [
      'mistralai/Mixtral-8x22B-Instruct-v0.1',
      'mistralai/Mixtral-8x7B-Instruct-v0.1',
      'HuggingFaceH4/zephyr-orpo-141b-A35b-v0.1',
    ],
    'More examples': true,
    LoRA: true,
  },
  {
    'Model Architecture': 'MPTForCausalLM',
    'Main Model': 'MPT',
    Models: ['MPT'],
    'HuggingFace model examples': ['mosaicml/mpt-30b'],
    'More examples': true,
    LoRA: false,
  },
  {
    'Model Architecture': 'MT5ForConditionalGeneration',
    'Main Model': 'MT5',
    Models: ['MT5'],
    'HuggingFace model examples': ['google/mt5-xxl'],
    'More examples': true,
    LoRA: true,
  },
  {
    'Model Architecture': 'OPTForcausalLM',
    'Main Model': 'OPT',
    Models: ['OPT'],
    'HuggingFace model examples': ['facebook/opt-66b'],
    'More examples': true,
    LoRA: false,
  },
  {
    'Model Architecture': 'Phi3ForCausalLM',
    'Main Model': 'Phi3',
    Models: ['Phi-3.5', 'Phi-3'],
    'HuggingFace model examples': [
      'microsoft/Phi-3.5-MoE-instruct',
      'microsoft/Phi-3-mini-128k-instruct',
    ],
    'More examples': true,
    LoRA: true,
  },
  {
    'Model Architecture': 'PhiForCausalLM',
    'Main Model': 'Phi',
    Models: ['Phi-2', 'Phi-1'],
    'HuggingFace model examples': ['microsoft/phi-2'],
    'More examples': true,
    LoRA: true,
  },
  {
    'Model Architecture': 'Qwen2ForCausalLM',
    'Main Model': 'Qwen2',
    Models: ['Qwen2.5', 'Qwen2', 'Qwen1.5'],
    'HuggingFace model examples': [
      'Qwen/Qwen2.5-72B-Instruct',
      'Qwen/Qwen2-72B-Instruct',
      'Qwen/Qwen1.5-7B-Chat',
    ],
    'More examples': true,
    LoRA: true,
  },
  {
    'Model Architecture': 'SolarForCausalLM',
    'Main Model': 'Solar',
    Models: ['Solar'],
    'HuggingFace model examples': ['upstage/solar-pro-preview-instruct'],
    'More examples': false,
    LoRA: false,
  },
  {
    'Model Architecture': 'Starcoder2ForCausalLM',
    'Main Model': 'StarCoder2',
    Models: ['StarCoder 2'],
    'HuggingFace model examples': ['bigcode/starcoder2-15b'],
    'More examples': true,
    LoRA: false,
  },
  {
    'Model Architecture': 'T5ForConditionalGeneration',
    'Main Model': 'T5',
    Models: ['FLAN-T5'],
    'HuggingFace model examples': ['google/flan-t5-xxl'],
    'More examples': true,
    LoRA: true,
  },
];

export const serverlessModels: {
  ID: string;
  'Model name': string;
  'Model code': string;
  Pricing: { value: number; unit: string };
}[] = [
  {
    ID: 'meta-llama-3.1-8b-instruct',
    'Model name': 'Llama 3.1 8B Instruct',
    'Model code': 'Meta-Llama-3.1-8B-Instruct',
    Pricing: { value: 0.1, unit: '1M tokens' },
  },
  {
    ID: 'meta-llama-3.1-70b-instruct',
    'Model name': 'Llama 3.1 70B Instruct',
    'Model code': 'Meta-Llama-3.1-70B-Instruct',
    Pricing: { value: 0.6, unit: '1M tokens' },
  },
  {
    ID: 'mixtral-8x7b-instruct-v0-1',
    'Model name': 'Mixtral 8x7B Instruct v0.1',
    'Model code': 'Mixtral-8x7B-Instruct-v0.1',
    Pricing: { value: 0.4, unit: '1M tokens' },
  },
];

export const dedicatedModels: {
  'Model architecture': string;
  'Model name': string;
}[] = [
  {
    'Model architecture': 'LlamaForCausalLM',
    'Model name': 'Meta-Llama-3.1-8B-Instruct',
  },
  {
    'Model architecture': 'LlamaForCausalLM',
    'Model name': 'Meta-Llama-3.1-70B-Instruct',
  },
  {
    'Model architecture': 'LlamaForCausalLM',
    'Model name': 'Meta-Llama-3-8B-Instruct',
  },
  {
    'Model architecture': 'LlamaForCausalLM',
    'Model name': 'Meta-Llama-3-70B-Instruct',
  },
  {
    'Model architecture': 'LlamaForCausalLM',
    'Model name': 'Llama-2-7b-chat-hf',
  },
  {
    'Model architecture': 'LlamaForCausalLM',
    'Model name': 'Llama-2-13b-chat-hf',
  },
  {
    'Model architecture': 'LlamaForCausalLM',
    'Model name': 'Llama-2-70b-chat-hf',
  },
  {
    'Model architecture': 'MixtralForCausalLM',
    'Model name': 'Mixtral-8x7B-Instruct-v0.1',
  },
  {
    'Model architecture': 'MistralForCausalLM',
    'Model name': 'Mistral-7B-Instruct-v0.1',
  },
  {
    'Model architecture': 'MistralForCausalLM',
    'Model name': 'Mistral-7B-Instruct-v0.2',
  },
  {
    'Model architecture': 'MistralForCausalLM',
    'Model name': 'Mistral-7B-Instruct-v0.3',
  },
  {
    'Model architecture': 'Gemma2ForCausalLM',
    'Model name': 'gemma-2-2b-it',
  },
  {
    'Model architecture': 'Gemma2ForCausalLM',
    'Model name': 'gemma-2-9b-it',
  },
  {
    'Model architecture': 'Gemma2ForCausalLM',
    'Model name': 'gemma-2-27b-it',
  },
  {
    'Model architecture': 'Qwen2ForCausalLM',
    'Model name': 'Qwen1.5-7B-Chat',
  },
  {
    'Model architecture': 'Qwen2ForCausalLM',
    'Model name': 'Qwen2-7B-Instruct',
  },
  {
    'Model architecture': 'Qwen2ForCausalLM',
    'Model name': 'Qwen2-72B-Instruct',
  },
  {
    'Model architecture': 'Qwen2ForCausalLM',
    'Model name': 'Qwen2.5-7B-Instruct',
  },
  {
    'Model architecture': 'Qwen2ForCausalLM',
    'Model name': 'Qwen2.5-72B-Instruct',
  },
  {
    'Model architecture': 'Phi3ForCausalLM',
    'Model name': 'Phi-3-mini-4k-instruct',
  },
  {
    'Model architecture': 'Phi3ForCausalLM',
    'Model name': 'Phi-3-mini-128k-instruct',
  },
];
